import { Component, OnInit } from '@angular/core';
import { UserParam } from 'src/app/classes/json-interface';
import { CUtilit } from 'src/app/classes/utilit';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';


@Component({
  templateUrl: './param.component.html',
  styleUrls: ['./param.component.css']
})
export class DialogParamComponent implements OnInit {

  public static openParam(matDialog: MatDialog) {
    const dialogParamRef = matDialog.open(DialogParamComponent,
      {
        width: '75%',
        disableClose: true
      }
    );
  }

  HTML_Param: UserParam = CUtilit.loadOrInitUserParam();

  constructor(private mDialogRef: MatDialogRef<DialogParamComponent>) {

  }

  ngOnInit() {

  }

  onDialogBtnClick(type: any) {
    switch (type) {
      case 'save' :
        if (this.HTML_Param) CUtilit.saveUserParam(this.HTML_Param);
        this.mDialogRef.close();
        break;
      case 'close' :
        this.mDialogRef.close();
        break;
    }
  }
}
